import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DOCUMENTS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";
import { FieldValues } from "react-hook-form";

interface mutateProps {
  communityId: string;
  data: FieldValues;
}

const mutateUpdateBillingDoc = async ({ communityId, data }: mutateProps) => {
  return await axiosAuth.put(`${DOCUMENTS_API(communityId)}/billing/parked`, data);
};

const useUpdateBillingDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateBillingDoc,
    ...queryParams,
  });

export default useUpdateBillingDocMutation;
